<script>
export default {
    name: 'PrivacyPolicy',
};
</script>
<template>
    <div id="privacy-policy" class="container pt-5">
        <div class="bg-white pt-5 pb-5">
            <h2 class="text-center">Polityka Prywatnosci</h2>
        </div>

        <div class="bg-white p-5 mt-3">
            <h3 class="mb-3">Polityka prywatności</h3>
            <p>
                Administratorem danych osobowych jest Adrianna Sobol. z siedzibą przy ul. Naruszewicza 8 m 4 w
                Warszawie, 02-627, NIP: 5252421703.
            </p>

            <p>
                Zastrzegamy sobie prawo do wprowadzania zmian w Polityce Prywatności. Każdego klienta Z
                Zdrowie zaczyna się w głowie i użytkownika serwisów oraz publikacji należących do Zdrowie
                zaczyna się w głowie obowiązuje aktualna Polityka Prywatności.
            </p>

            <p>
                Jakiekolwiek wprowadzane zmiany nie wpływają na podstawową zasadę: Zdrowie zaczyna się w głowie nie
                sprzedaje i nie udostępnia osobom trzecim danych personalnych czy adresowych klientów / użytkowników
                swoich serwisów, za wyjątkiem podmiotów, z których usług korzysta w celu poprawnego prowadzenia serwisu.
            </p>
        </div>

        <div class="bg-white p-5 mt-3">
            <h3 class="mb-3">Ochrona Danych Osobowych</h3>
            <p>
                W czasie korzystania z serwisu Zdrowie zaczyna się w głowie możesz zostać poproszona/y o podanie
                niektórych swoich danych osobowych poprzez wypełnienie formularza lub w inny sposób. Dane, o które
                będziesz proszona/y, to w większości przypadków: imię, nazwisko, adres e-mail oraz w przypadku,
                gdy chcesz otrzymać fakturę - także nazwa firmy, numer NIP oraz adres firmy. Wymagamy tylko tych danych,
                które są niezbędne do działania serwisu. Niepodanie wymaganych danych zablokuje tę czynność, w trakcie
                której wymagane było podanie danych.
            </p>

            <p>
                W serwisie przetwarzamy informacje o użytkownikach w następujący sposób:<br>
                - przetwarzanie danych podanych dobrowolnie w formularzach internetowych,<br>
                - korzystanie z plików cookies,<br>
                - gromadzenie logów serwera www.
            </p>

            <p>
                Zbieramy informacje podane dobrowolnie przez użytkowników w udostępnionych na stronie formularzach:
                formularzu rejestracji konta w serwisie, formularzu zapisu na newsletter oraz formularzu kontaktowym.
            </p>

            <p>
                Podanie danych w formularzu rejestracji konta w serwisie jest dobrowolne, ale niezbędne do świadczenia
                usługi utrzymywania konta w serwisie i udostępniania w nim materiałów i informacji z zakresu wiedzy
                biznesowej i rozwoju osobistego. Dane osobowe, jakie nam przekażesz w tym formularzu są przez nas
                przetwarzane wyłącznie w celu zawarcia i wykonywania umowy o świadczenie powyższych usług. Dane te
                będziemy przetwarzać do czasu zakończenia umowy, a po tym czasie możemy je nadal przetwarzać przez
                okres przedawnienia ewentualnych roszczeń.
            </p>

            <p>
                Podanie danych w formularzu zapisu na newsletter jest dobrowolne, ale niezbędne do wysłania Ci newslettera.
                Dane osobowe, jakie nam przekażesz w tym formularzu są przez nas przetwarzane wyłącznie w celu przesyłania
                Ci informacji z zakresu wiedzy biznesowej i rozwoju osobistego, informacji o nowościach w serwisie oraz
                informacji handlowych. Dane te będziemy przetwarzać do czasu wycofania przez Ciebie zgody.
            </p>

            <p>
                Podanie danych w formularzu kontaktowym jest dobrowolne, ale niezbędne do udzielenia odpowiedzi na
                przesłaną przez Ciebie wiadomość. Dane osobowe, jakie nam przekażesz w tym formularzu są przez nas
                przetwarzane wyłącznie w celu udzielenia odpowiedzi na przesłaną przez Ciebie wiadomość, a po tym
                czasie mogą być przetwarzane przez okres przedawnienia ewentualnych roszczeń.
            </p>

            <p>
                Podanie danych w formularzu zamówienia w sklepie znajdującym się w serwisie jest dobrowolne, ale
                niezbędne do realizacji zamówienia. Dane osobowe, jakie nam przekażesz w tym formularzu są przez nas
                przetwarzane wyłącznie w celu realizacji zamówienia, tj. zawarcia i wykonywania umowy. Przetwarzamy
                również dane osobowe, gdy jest to niezbędne do marketingu bezpośredniego na podstawie uzasadnionego
                interesu administratora, a przetwarzanie nie narusza praw i wolności osoby, której dane dotyczą.
                Dane osobowe, jakie nam przekażesz w tym formularzu będą przez nas przetwarzane przez okres wykonywania
                umowy, a po tym czasie mogą być przetwarzane przez okres przedawnienia ewentualnych roszczeń.
            </p>

            <p>
                Nie sprzedajemy danych, a możemy je udostępniać tylko podmiotom upoważnionym, w tym w celu świadczenia
                dla nas usług związanych z poprawnym działaniem serwisu i prawidłowym wykonywaniem naszych usług.
            </p>

            <p>
                Możemy też mieć obowiązek udzielania informacji zebranych przez serwis upoważnionym organom na podstawie
                zgodnych z prawem żądań w zakresie wynikającym z żądania.
            </p>
        </div>

        <div class="bg-white p-5 mt-3">
            <h3 class="mb-3">Cookies (Ciasteczka)</h3>
            <p>
                W serwisie Zdrowie zaczyna się w głowie wykorzystujemy cookies, czyli małe pliki tekstowe wysyłane do
                komputera internauty identyfikujące go w sposób potrzebny do uproszczenia lub umorzenia danej operacji.
                Cookies są nieszkodliwe ani dla komputera ani dla jego użytkownika i jego danych.
            </p>

            <p>
                Pliki cookies wykorzystujemy w celu prowadzenia analiz i tworzenia statystyk, które pomagają zrozumieć,
                w jaki sposób użytkownicy serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich
                struktury i zawartości. W tym celu korzysta z narzędzi Google Analytics. W celu zablokowania
                wykorzystywania danych w Google Analitycs. Możesz zainstalować dodatek blokujący Google Analytics w
                swojej przeglądarce, dostępny tu:
                <a href="https://tools.google.com/dlpage/gaoptout/?hl=pl" target="_blank">
                    https://tools.google.com/dlpage/gaoptout/?hl=pl
                </a>.
            </p>

            <p>
                Cookies używamy ich również do utrzymania sesji użytkowników, dzięki której nie ma konieczności
                ponownego wpisywania loginu i hasła.
            </p>

            <p>
                Informacje o niektórych zachowaniach użytkowników podlegają logowaniu w warstwie serwerowej. Dane te są
                wykorzystywane wyłącznie w celu administrowania serwisem oraz w celu zapewnienia jak najlepszej obsługi
                świadczonych usług hostingowych.
            </p>
        </div>

        <div class="bg-white p-5 mt-3">
            <h3 class="mb-3">Bezpieczeństwo danych osobowych i prawa użytkowników</h3>
            <p>Dbamy o prywatność naszych użytkowników.</p>

            <p>
                Przetwarzamy dane osobowe Klientów zgodnie z rozporządzeniem Parlamentu Europejskiego i Rady (UE)
                2016/679 z 27 kwietnia 2016 roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych
                osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
                (ogólnym rozporządzeniem o ochronie danych, RODO) oraz powszechnie obowiązującymi przepisami prawa.
            </p>

            <p>
                Stosujemy przy tym odpowiednie środki techniczne i organizacyjne zapewniające ochronę przetwarzanych
                danych adekwatne do zagrożeń oraz kategorii danych objętych ochroną, a w szczególności zabezpieczamy
                dane osobowe przed udostępnieniem ich osobom nieupoważnionym, utratą czy uszkodzeniem.
            </p>

            <p>
                Pamiętaj, że w stosunku do wszelkich przekazanych nam danych osobowych masz prawo
                dostępu do swoich danych osobowych, ich sprostowania, usunięcia lub ograniczenia
                przetwarzania, sprzeciwu, a także prawo do przenoszenia tych danych i wniesienia skargi do

                organu nadzorczego. W celu realizacji swoich praw możesz skontaktować się z nami pod adres :
                <a href="mailto:biuro@adriannasobol.pl">biuro@adriannasobol.pl</a>
            </p>
        </div>
    </div>
</template>
